import React, { useEffect, useMemo, useRef, useState } from "react";
import { StepUpSpinner } from "../../../Components/Loader";
import {
  CircularProgress,
  Grid,
  Box,
  Card,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import {
  useGetPositionQuery,
  useEmpPayrollPayrollRecordReportQuery,
  useGetTeamSerchOnlyQuery,
} from "../../../Api/attoDeskApi";
import {
  IEmployeePayroll,
  IPosition,
  IPayrollDateRangeList,
  IPayrollEachEmployeDateList,
  ITeam,
  IEmployeePunchRecord,
} from "../../../Api/Interface/api.interface";
import { useStyles } from "../../../theme/appStyles";
import dayjs, { Dayjs } from "dayjs";
import { useNotifier } from "../../../Core/Notifier";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import useUser from "../../../Core/hook/useUser";
import LocalPrintshopSharpIcon from "@mui/icons-material/LocalPrintshopSharp";
import "jspdf-autotable";
import ReactToPrint from "react-to-print";
import { useSelector } from "react-redux";
import { RootState } from "../../../Store";

const formatTime = (time: string | undefined) => {
  if (!time) return "";
  const [hour, minute] = time.split(":").map(Number);
  const date = new Date();
  date.setHours(hour, minute);
  return new Intl.DateTimeFormat("en-CA", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  }).format(date);
};

const Index: React.FC = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [searchParams] = useSearchParams();
  const { id: payrollId } = useParams<{
    id: string;
  }>();
  const { companyLogo, logowidthPrint, companyName } = useSelector(
    (state: RootState) => state.company
  );
  const employeeId = searchParams.get("empid");

  const componentRef = useRef<HTMLDivElement>(null);
  const { userHasRight } = useUser();
  const [searchQueryCustomer, setSearchQueryCustomer] = useState<string>("");
  const [currentSearchQueryCustomer, setCurrentSearchQueryCustomer] =
    useState<string>("");
  const [showDropdownCustomer, setShowDropdownCustomer] =
    useState<boolean>(false);
  const [selectedEmpId, setSelectedEmpId] = useState<string>(" ");

  const [selectedStartDate, setSelectedStartDate] = useState<Dayjs | undefined>(
    undefined
  );
  const [selectedEndDate, setSelectedEndDate] = useState<Dayjs | undefined>(
    undefined
  );
  const {
    data: tenantData,
    isLoading: tenantIsLoading,
    isError: tenantIsError,
    refetch: tenantRefetch,
  } = useGetTeamSerchOnlyQuery({
    searchText: searchQueryCustomer,
    id: "",
  });

  const { data, isLoading, isError, refetch } =
    useEmpPayrollPayrollRecordReportQuery({
      payrollId: String(payrollId),
      empid: String(employeeId),
    });

  const { data: positionData, isLoading: positionLoading } =
    useGetPositionQuery({
      searchText: "",
    });

  const payrollSummaryDataList = useMemo(() => {
    return data?.recordDate as IPayrollDateRangeList;
  }, [data?.recordDate]);

  const positionList = useMemo(() => {
    return positionData?.data as IPosition[];
  }, [positionData?.data]);

  const teamList: ITeam[] = Array.isArray(tenantData?.data)
    ? (tenantData?.data as ITeam[])
    : [];

  const postionMap = useMemo(() => {
    const map = new Map();
    positionList?.forEach((category) => {
      map.set(category.id, category.positionName);
    });
    return map;
  }, [positionList]);

  useEffect(() => {
    if (payrollSummaryDataList?.startDate) {
      setSelectedStartDate(dayjs(payrollSummaryDataList.startDate));
    }
    if (payrollSummaryDataList?.endDate) {
      setSelectedEndDate(dayjs(payrollSummaryDataList.endDate));
    }
  }, [payrollSummaryDataList]);

  const project: IEmployeePayroll[] = useMemo(() => {
    if (tenantData && Array.isArray(tenantData.data)) {
      return tenantData.data as IEmployeePayroll[];
    }
    return [];
  }, [tenantData]);

  const employeeData = Array.isArray(data?.data) ? data?.data : [];
  const currentMonthDate = dayjs().format("YYYY MMM, DD");

  return (
    <div>
      <Card className={classes.quotesCardStaff}>
        <Grid container spacing={2}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Grid container spacing={2} alignItems="center" p={5}>
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                sx={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Grid
                  container
                  spacing={1}
                  justifyContent="flex-end"
                  sx={{ display: "flex" }}
                >
                  <Grid item>
                    <ReactToPrint
                      trigger={() => (
                        <Button
                          variant="contained"
                          startIcon={<LocalPrintshopSharpIcon />}
                          className={classes.addButtonPdfExcel}
                        >
                          Print
                        </Button>
                      )}
                      content={() => componentRef.current}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <div ref={componentRef}>
            <Grid item lg={12} md={12} sm={12} xs={12} mt={5}>
              <Grid container spacing={2} justifyContent={"center"}>
                <Grid item lg={4} md={6} sm={6} xs={6} mb={2}>
                  <Grid container px={4}>
                    <img
                      src={companyLogo}
                      alt="step"
                      style={{
                        width: "150px",
                        height: "60px",
                        display: "block",
                      }}
                    />
                  </Grid>
                </Grid>

                <Grid item lg={8} md={6} sm={6} xs={6} mb={2}>
                  <Typography
                    variant="subtitle1"
                    textAlign={"right"}
                    className={classes.cardTitle256}
                    px={5}
                  >
                    Payroll Summary Report
                  </Typography>
                  <Typography variant="subtitle1" textAlign={"right"} px={5}>
                    {"Period: "}
                    {selectedStartDate
                      ? selectedStartDate.format("MMM-DD, YYYY")
                      : ""}
                    {" to "}{" "}
                    {selectedEndDate
                      ? selectedEndDate.format("MMM-DD, YYYY")
                      : ""}
                  </Typography>
                </Grid>
                {isLoading ? (
                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    justifyContent="center"
                    alignItems="center"
                  >
                   <Box display="flex" justifyContent="center" alignItems="center" height="10vh">
                      <StepUpSpinner size="medium" />
                    </Box>
                  </Grid>
                ) : isError ? (
                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    sx={{ textAlign: "center" }}
                  >
                    {isError ? "Something went wrong" : "No data available"}
                  </Grid>
                ) : (
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    {employeeData?.map(
                      (
                        record: {
                          employee: IEmployeePayroll;
                          attendance: IEmployeePunchRecord[];
                        },
                        index
                      ) => {
                        let backgroundColor;
                        if (index % 2 === 0) {
                          backgroundColor = "#ffffff";
                        } else if (index % 2 === 1) {
                          backgroundColor = "#ffffff";
                        } else {
                          backgroundColor = "#000000";
                        }
                        return (
                          <Grid
                            container
                            spacing={2}
                            key={record.employee.id}
                            mb={5}
                            p={1}
                            pb={5}
                            sx={{
                              backgroundColor: backgroundColor,
                            }}
                          >
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Typography className={classes.h4} px={4}>
                                {record.employee.employee_name}
                              </Typography>
                              <Typography variant="subtitle1" px={4}>
                                {postionMap.get(
                                  record.employee.employee_position_id
                                ) || ""}
                              </Typography>
                            </Grid>
                            {record.attendance.length > 0 && (
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <TableContainer sx={{ px: 4 }}>
                                  <Table className={classes.table}>
                                    <TableHead
                                      className={classes.tableHeaderRow}
                                    >
                                      <TableRow>
                                        <TableCell
                                          className={classes.tablheader}
                                        >
                                          <strong>Date</strong>
                                        </TableCell>
                                        <TableCell
                                          className={classes.tablheader}
                                          sx={{ textAlign: "left" }}
                                        >
                                          <strong>Records</strong>
                                        </TableCell>
                                        <TableCell
                                          className={classes.tablheader}
                                          sx={{ textAlign: "right" }}
                                        >
                                          <strong>Actual Hours</strong>
                                        </TableCell>
                                        <TableCell
                                          className={classes.tablheader}
                                          sx={{ textAlign: "right" }}
                                        >
                                          <strong>Total Break Hours</strong>
                                        </TableCell>

                                        <TableCell
                                          className={classes.tablheader}
                                          sx={{ textAlign: "right" }}
                                        >
                                          <strong>Total working hours</strong>
                                        </TableCell>

                                        <TableCell
                                          className={classes.tablheader}
                                          sx={{ textAlign: "right" }}
                                        >
                                          <strong>Hourly Salary</strong>
                                        </TableCell>

                                        <TableCell
                                          className={classes.tablheader}
                                          sx={{ textAlign: "right" }}
                                        >
                                          <strong>Total Amount</strong>
                                        </TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {isLoading ? (
                                        <TableRow>
                                          <TableCell
                                            colSpan={20}
                                            align="center"
                                          >
                                            <Box display="flex" justifyContent="center" alignItems="center" height="10vh">
                      <StepUpSpinner size="medium" />
                    </Box>
                                          </TableCell>
                                        </TableRow>
                                      ) : isError ||
                                        record.attendance.length === 0 ? (
                                        <TableRow>
                                          <TableCell
                                            colSpan={20}
                                            align="center"
                                          >
                                            {isError
                                              ? "Error fetching data"
                                              : "No data available"}
                                          </TableCell>
                                        </TableRow>
                                      ) : (
                                        record.attendance.map((att) => (
                                          <TableRow
                                            key={att.id}
                                            className={classes.tableRowHover}
                                          >
                                            <TableCell
                                              scope="row"
                                              className={classes.tablCell}
                                            >
                                              {dayjs(att.recordDate).format(
                                                "YYYY-MM-DD"
                                              )}
                                            </TableCell>
                                            <TableCell
                                              scope="row"
                                              className={classes.tablCell}
                                              sx={{ textAlign: "left" }}
                                            >
                                              {att.punchDetails.length > 0 ? (
                                                att.punchDetails.map(
                                                  (punchDetail, index) => (
                                                    <span key={index}>
                                                      {formatTime(
                                                        punchDetail.punch_in_time
                                                      )}{" "}
                                                      -{" "}
                                                      {formatTime(
                                                        punchDetail.punch_out_time
                                                      )}
                                                      {index !==
                                                        att.punchDetails
                                                          .length -
                                                          1 && ", "}
                                                    </span>
                                                  )
                                                )
                                              ) : (
                                                <span> </span>
                                              )}
                                            </TableCell>
                                            <TableCell
                                              scope="row"
                                              className={classes.tablCell}
                                              sx={{ textAlign: "right" }}
                                            >
                                              {att.break_hours === null ||
                                              att.total_hours === null ||
                                              isNaN(
                                                parseFloat(
                                                  String(att.break_hours)
                                                )
                                              ) ||
                                              isNaN(
                                                parseFloat(
                                                  String(att.total_hours)
                                                )
                                              )
                                                ? ""
                                                : parseFloat(
                                                    String(att.break_hours)
                                                  ) +
                                                    parseFloat(
                                                      String(att.total_hours)
                                                    ) ===
                                                  0
                                                ? "-"
                                                : `${(
                                                    parseFloat(
                                                      String(att.break_hours)
                                                    ) +
                                                    parseFloat(
                                                      String(att.total_hours)
                                                    )
                                                  ).toFixed(2)} hrs`}
                                            </TableCell>
                                            <TableCell
                                              scope="row"
                                              className={classes.tablCell}
                                              sx={{ textAlign: "right" }}
                                            >
                                              {att.break_hours === null ||
                                              isNaN(
                                                parseFloat(
                                                  String(att.break_hours)
                                                )
                                              )
                                                ? ""
                                                : parseFloat(
                                                    String(att.break_hours)
                                                  ) === 0
                                                ? "-"
                                                : `${parseFloat(
                                                    String(att.break_hours)
                                                  ).toFixed(2)} hrs`}
                                            </TableCell>
                                            <TableCell
                                              scope="row"
                                              className={classes.tablCell}
                                              sx={{ textAlign: "right" }}
                                            >
                                              {att.total_hours === null ||
                                              isNaN(
                                                parseFloat(
                                                  String(att.total_hours)
                                                )
                                              )
                                                ? ""
                                                : parseFloat(
                                                    String(att.total_hours)
                                                  ) === 0
                                                ? "-"
                                                : `${parseFloat(
                                                    String(att.total_hours)
                                                  ).toFixed(2)} hrs`}
                                            </TableCell>

                                            <TableCell
                                              scope="row"
                                              className={classes.tablCell}
                                              sx={{ textAlign: "right" }}
                                            >
                                              {record.employee.hourly_salary ===
                                                null ||
                                              isNaN(
                                                parseFloat(
                                                  String(
                                                    record.employee
                                                      .hourly_salary
                                                  )
                                                )
                                              )
                                                ? ""
                                                : parseFloat(
                                                    String(
                                                      record.employee
                                                        .hourly_salary
                                                    )
                                                  ) === 0
                                                ? "-"
                                                : `$ ${parseFloat(
                                                    String(
                                                      record.employee
                                                        .hourly_salary
                                                    )
                                                  ).toFixed(2)}`}
                                            </TableCell>

                                            <TableCell
                                              scope="row"
                                              className={classes.tablCell}
                                              sx={{ textAlign: "right" }}
                                            >
                                              {"$ "}
                                              {(
                                                (Number(att.total_hours) || 0) *
                                                (Number(
                                                  record.employee?.hourly_salary
                                                ) || 0)
                                              ).toFixed(2)}
                                            </TableCell>
                                          </TableRow>
                                        ))
                                      )}
                                      <TableRow
                                      // className={classes.tableRowHover}
                                      >
                                        <TableCell scope="row"></TableCell>
                                        <TableCell
                                          scope="row"
                                          sx={{ textAlign: "center" }}
                                        ></TableCell>
                                        <TableCell
                                          scope="row"
                                          sx={{ textAlign: "right" }}
                                        >
                                          <Typography
                                            className={
                                              classes.cardGreenTypograpy
                                            }
                                          ></Typography>
                                        </TableCell>
                                        <TableCell
                                          scope="row"
                                          sx={{ textAlign: "right" }}
                                        >
                                          <Typography
                                            className={
                                              classes.cardGreenTypograpy
                                            }
                                          ></Typography>
                                        </TableCell>
                                        <TableCell
                                          scope="row"
                                          // className={classes.tablCellpx}
                                          sx={{ textAlign: "right" }}
                                        >
                                          {Number(
                                            record.employee
                                              .total_normal_hours || 0
                                          ).toFixed(2)}
                                          {" hrs"}
                                        </TableCell>
                                        <TableCell
                                          scope="row"
                                          sx={{ textAlign: "right" }}
                                        >
                                          <Typography
                                            className={
                                              classes.cardGreenTypograpy
                                            }
                                          ></Typography>
                                        </TableCell>
                                        <TableCell
                                          scope="row"
                                          // className={classes.tablCellpx}
                                          sx={{ textAlign: "right" }}
                                        >
                                          {"$ "}
                                          {Number(
                                            Number(
                                              record.employee
                                                .total_normal_hours || 0
                                            ) *
                                              Number(
                                                record.employee.hourly_salary ||
                                                  0
                                              )
                                          ).toFixed(2)}
                                        </TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              </Grid>
                            )}
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Grid container spacing={2} sx={{ px: 5 }}>
                                <Grid item lg={6} md={6} sm={4}></Grid>

                                <Grid
                                  item
                                  lg={6}
                                  md={6}
                                  sm={8}
                                  xs={12}
                                  className={classes.cardGreenBAckGroundColor}
                                >
                                  <Grid container spacing={2}>
                                    <Grid item lg={12} md={12} sm={12} xs={12}>
                                      <Grid container spacing={2}>
                                        <Grid
                                          item
                                          lg={8}
                                          md={8}
                                          sm={8}
                                          xs={8}
                                          sx={{
                                            display: "flex",
                                            justifyContent: "flex-start",
                                            alignItems: "center",
                                          }}
                                        >
                                          <Typography
                                            className={
                                              classes.cardGreenTypograpy
                                            }
                                          >
                                            Normal Working Amount (
                                            {Number(
                                              record.employee
                                                .total_normal_hours || 0
                                            ).toFixed(2)}
                                            {" hrs * $"}
                                            {Number(
                                              record.employee.hourly_salary || 0
                                            ).toFixed(2)}
                                            )
                                          </Typography>
                                        </Grid>

                                        <Grid
                                          item
                                          lg={4}
                                          md={4}
                                          sm={4}
                                          xs={4}
                                          sx={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            alignItems: "center",
                                          }}
                                          paddingRight={2}
                                        >
                                          <Typography
                                            className={
                                              classes.cardGreenTypograpy
                                            }
                                          >
                                            {"$ "}
                                            {Number(
                                              Number(
                                                record.employee
                                                  .total_normal_hours || 0
                                              ) *
                                                Number(
                                                  record.employee
                                                    .hourly_salary || 0
                                                )
                                            ).toFixed(2)}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                    <Grid item lg={12} md={12} sm={12} xs={12}>
                                      <Grid container spacing={2}>
                                        <Grid
                                          item
                                          lg={8}
                                          md={8}
                                          sm={8}
                                          xs={8}
                                          sx={{
                                            display: "flex",
                                            justifyContent: "flex-start",
                                            alignItems: "center",
                                          }}
                                        >
                                          <Typography
                                            className={
                                              classes.cardGreenTypograpy
                                            }
                                          >
                                            OT Amount (
                                            {Number(
                                              record.employee.total_ot_hours ||
                                                0
                                            ).toFixed(2)}
                                            {" hrs * $"}
                                            {Number(
                                              record.employee
                                                .ot_hourly_salary || 0
                                            ).toFixed(2)}
                                            )
                                          </Typography>
                                        </Grid>

                                        <Grid
                                          item
                                          lg={4}
                                          md={4}
                                          sm={4}
                                          xs={4}
                                          sx={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            alignItems: "center",
                                          }}
                                          paddingRight={2}
                                        >
                                          <Typography
                                            className={
                                              classes.cardGreenTypograpy
                                            }
                                          >
                                            {"$ "}
                                            {Number(
                                              Number(
                                                record.employee
                                                  .total_ot_hours || 0
                                              ) *
                                                Number(
                                                  record.employee
                                                    .ot_hourly_salary || 0
                                                )
                                            ).toFixed(2)}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                    <Grid item lg={12} md={12} sm={12} xs={12}>
                                      <Grid container spacing={2}>
                                        <Grid
                                          item
                                          lg={8}
                                          md={8}
                                          sm={8}
                                          xs={8}
                                          sx={{
                                            display: "flex",
                                            justifyContent: "flex-start",
                                            alignItems: "center",
                                          }}
                                        >
                                          <Typography
                                            className={
                                              classes.cardGreenTypograpy
                                            }
                                          >
                                            Adjustment Amount
                                          </Typography>
                                        </Grid>

                                        <Grid
                                          item
                                          lg={4}
                                          md={4}
                                          sm={4}
                                          xs={4}
                                          sx={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            alignItems: "center",
                                          }}
                                          paddingRight={2}
                                          pb={1}
                                          borderBottom={0.5}
                                        >
                                          <Typography
                                            className={
                                              classes.cardGreenTypograpy
                                            }
                                          >
                                            {"$ "}
                                            {Number(
                                              record.employee.bonus_amount || 0
                                            ).toFixed(2)}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                    <Grid
                                      item
                                      lg={12}
                                      md={12}
                                      sm={12}
                                      xs={12}
                                      py={2}
                                    >
                                      <Grid container spacing={2}>
                                        <Grid
                                          item
                                          lg={8}
                                          md={8}
                                          sm={8}
                                          xs={8}
                                          sx={{
                                            display: "flex",
                                            justifyContent: "flex-start",
                                            alignItems: "center",
                                          }}
                                        >
                                          <Typography className={classes.h4}>
                                            Total Amount
                                          </Typography>
                                        </Grid>

                                        <Grid
                                          item
                                          lg={4}
                                          md={4}
                                          sm={4}
                                          xs={4}
                                          sx={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            alignItems: "center",
                                          }}
                                          paddingRight={2}
                                        >
                                          <Typography className={classes.h4}>
                                            {"$ "}
                                            {Number(
                                              record.employee.total_salary || 0
                                            ).toFixed(2)}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        );
                      }
                    )}
                  </Grid>
                )}
              </Grid>
            </Grid>
          </div>
        </Grid>
      </Card>
    </div>
  );
};

export default Index;
